export const PRODUCT_STATUS = {
  ON_SHELF: 100,
  OFF_SHELF: 0,
}
